import { IonAlert, IonIcon } from "@ionic/react";
import { alertCircleOutline } from "ionicons/icons";
import { useState } from "react";
import PlayPauseButton from "./PlayPauseButton.jsx";
import StatusBadge from "./StatusBadge.jsx";
import TimerDisplay from "./TimerDisplay.jsx";
import { assignedEmployeeCount } from "../utils/assignments.js";
import { dateInput, formatTime } from "../utils/date.js";

function jobLabel(job) {
  return job?.internalLabel ? `${job.client?.name} - ${job.internalLabel}` : job?.client?.name;
}

export default function JobCard({
  job,
  currentUserId,
  canControlAnyTimer = false,
  onOpen,
  onToggleTimer,
}) {
  const [isRepeatWarningOpen, setIsRepeatWarningOpen] = useState(false);
  const currentRunningEntry = job.timeEntries?.find(
    (entry) => entry.userId === currentUserId && entry.isRunning,
  );
  const anyRunningEntry = job.timeEntries?.find((entry) => entry.isRunning);
  const running = Boolean(currentRunningEntry || (canControlAnyTimer && anyRunningEntry));
  const isLastRepeatedJob = Boolean(
    job.repeatGroupId &&
    job.repeatLastDate &&
    dateInput(job.scheduledStart) === dateInput(job.repeatLastDate),
  );

  function handleTimer(event) {
    event.stopPropagation();
    onToggleTimer(job, running);
  }

  function showRepeatWarning(event) {
    event.stopPropagation();
    setIsRepeatWarningOpen(true);
  }

  return (
    <>
      <button className={`job-card ${running ? "job-card-running" : ""}`} onClick={() => onOpen(job)}>
        <div className="job-card-main">
          <div className="job-card-topline">
            <div className="job-time">{formatTime(job.scheduledStart)} - {formatTime(job.scheduledEnd)}</div>
            {isLastRepeatedJob && (
              <span
                className="job-warning-button"
                onClick={showRepeatWarning}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    showRepeatWarning(event);
                  }
                }}
                role="button"
                tabIndex={0}
                aria-label="Repeated job expiry warning"
              >
                <IonIcon icon={alertCircleOutline} />
              </span>
            )}
          </div>
          <StatusBadge status={job.status} />
          <h3>{jobLabel(job) || "Client"}</h3>
          <p>{job.serviceAddress}</p>
          <div className="job-meta">
            <span>{assignedEmployeeCount(job)} assigned</span>
            <TimerDisplay
              entries={job.timeEntries}
              fallbackSeconds={(job.estimatedDuration || 0) * 60}
            />
          </div>
        </div>
        <PlayPauseButton running={running} onClick={handleTimer} />
      </button>

      <IonAlert
        cssClass="metora-alert"
        isOpen={isRepeatWarningOpen}
        header="Repeated Job Ending"
        message="This repeated job is about to expire. Edit the job if it needs to continue."
        buttons={["OK"]}
        onDidDismiss={() => setIsRepeatWarningOpen(false)}
      />
    </>
  );
}
